import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginSuccess } from '../../redux/authSlice';
import { useLoginMutation } from '../../redux/api/authApi';
import { getApiError } from '../../redux/api/baseQuery';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [doLogin, { isLoading }] = useLoginMutation();
  const isAuthenticated = useSelector((state) => state.auth.authenticated);

  const defaultFormValues = {
    username: '',
    password: '',
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  });

  const [formValues, setFormValues] = useState(defaultFormValues);
  const [hasLoginError, setHasLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [stayLoggedIn, setStayLoggedIn] = useState(true);

  const handleSubmit = (e) => {
    e?.preventDefault();
    doLogin(formValues)
      .unwrap()
      .then((response) => {
        dispatch(
          loginSuccess({
            accessExpiresAt: response.access_expiration,
            accessToken: response.access,
            firstname: response.user.first_name,
            lastname: response.user.last_name,
            id: response.user.pk,
            isSuperUser: response.is_superuser,
            refreshToken: response.refresh,
            refreshExpiresAt: response.refresh_expiration,
            stayLoggedIn: stayLoggedIn,
            userGroups: response.user_groups,
            username: response.user.username,
          })
        );
        navigate('/');
      })
      .catch((error) => {
        const e = getApiError(error);
        setHasLoginError(true);
        setLoginErrorMessage(
          e.code === 'invalid'
            ? 'Benutzername/Passwort falsch'
            : e.message
        );
      });
  };

  return (
    <div className='justify-content-center row'>
      <div className='col-lg-5 col-md-7'>
        <div className='card'>
          <form onSubmit={handleSubmit}>
            <div className='card-header'>
              <strong>GK Office Login</strong>
            </div>
            <div className='card-body'>
              {hasLoginError && (
                <div className='alert alert-warning w-100'>
                  {loginErrorMessage ||
                    'Die Anmeldung ist fehlgeschlagen. Bitte Benutzernamen und Passwort prüfen!'}
                </div>
              )}
              <div className='form-group'>
                <label htmlFor='username' className='form-label mt-2 mb-1'>
                  Benutzername
                </label>
                <input
                  id='username'
                  className='form-control form-control-sm'
                  type='text'
                  value={formValues.username}
                  onChange={(e) =>
                    setFormValues((fv) => ({ ...fv, username: e.target.value }))
                  }
                />
                <label htmlFor='password' className='form-label mt-2 mb-1'>
                  Passwort
                </label>
                <div className='input-group'>
                  <input
                    id='password'
                    className='form-control form-control-sm'
                    type={showPassword ? 'text' : 'password'}
                    value={formValues.password}
                    onChange={(e) =>
                      setFormValues((fv) => ({
                        ...fv,
                        password: e.target.value,
                      }))
                    }
                  />
                  <button
                    className='btn btn-outline-secondary'
                    type='button'
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {/*<a href='/forgot-password' className='form-text text-muted'>*/}
                {/*  <small>Passwort vergessen?</small>*/}
                {/*</a>*/}
                {/*<div className='my-2 form-check'>*/}
                {/*  <input*/}
                {/*    checked={stayLoggedIn}*/}
                {/*    type='checkbox'*/}
                {/*    className='form-check-input'*/}
                {/*    id='stayLoggedIn'*/}
                {/*    onChange={(e) => setStayLoggedIn(e.target.checked)}*/}
                {/*  />*/}
                {/*  <label className='form-check-label' htmlFor='stayLoggedIn'>*/}
                {/*    Angemeldet bleiben*/}
                {/*  </label>*/}
                {/*</div>*/}
              </div>
              <div className='mt-3 mb-0 text-center'>
                <button
                  className='btn btn-primary'
                  type='submit'
                  disabled={isLoading}
                >
                  Anmelden
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
